import { Check } from "lucide-react";

export const ShadeGrid = ({ shades, qualityId, isPinned, onToggle }) => {
  if (!shades.length) {
    return (
      <p
        className="py-16 text-center text-sm"
        style={{ color: "var(--mp-muted)", fontFamily: "'Manrope', sans-serif" }}
        data-testid="shade-grid-empty"
      >
        No shades match that filter.
      </p>
    );
  }

  return (
    <div
      className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-2 sm:gap-3"
      data-testid="shade-grid"
    >
      {shades.map((shade) => {
        const picked = isPinned(qualityId, shade.number);
        return (
          <button
            key={shade.number}
            onClick={() => onToggle(shade)}
            data-testid={`shade-tile-${shade.number}`}
            aria-pressed={picked}
            aria-label={`Shade number ${shade.number}`}
            className="group relative rounded-sm overflow-hidden transition-transform duration-200 hover:-translate-y-0.5 focus:outline-none"
            style={{
              border: picked ? "2px solid var(--mp-copper)" : "1px solid var(--mp-line)",
            }}
          >
            <div className="aspect-square overflow-hidden" style={{ backgroundColor: shade.hex }}>
              <img
                src={shade.image_url}
                alt=""
                loading="lazy"
                width="320"
                height="320"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            </div>
            <div
              className="flex items-center justify-between px-1.5 py-1"
              style={{ backgroundColor: "var(--mp-card)" }}
            >
              <span
                className="text-[11px] sm:text-xs font-semibold tabular-nums"
                style={{ color: "var(--mp-text)", fontFamily: "'Manrope', sans-serif" }}
              >
                {shade.number}
              </span>
              {picked && (
                <Check className="w-3 h-3" style={{ color: "var(--mp-copper)" }} strokeWidth={3} />
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};
